///
/// EarthBrowser
///
/// Webcam Browser Feature
///
/// Manages webcam browser window lifecycle and command palette registration
///
/// Created by Matt Giger on 9/4/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useEffect } from 'react'
import { Video } from 'lucide-react'
import { WebcamBrowserRenderer } from '@/components/features/webcam-browser/WebcamBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const WEBCAM_WINDOW_ID = 'webcam-browser'
const WEBCAM_WINDOW_WIDTH = 860
const WEBCAM_WINDOW_HEIGHT = 600

export function WebcamBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const webcamWindow = datasetWindows[WEBCAM_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'webcam-browser',
			command: {
				id: 'webcams',
				title: 'Webcams',
				icon: <Video className="w-4 h-4 text-fuchsia-500" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						WEBCAM_WINDOW_ID,
						{
							id: WEBCAM_WINDOW_ID,
							title: 'Webcams',
							windowType: 'webcam',
							x: 150,
							y: 150,
							width: WEBCAM_WINDOW_WIDTH,
							height: WEBCAM_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	if (!webcamWindow) {
		return null
	}

	return (
		<WebcamBrowserRenderer
			windowId={WEBCAM_WINDOW_ID}
			windowState={webcamWindow}
		/>
	)
}
